module.exports = __webpack_public_path__ + "media/images/features/modification/illust-question-8aa4e2b773421205a323845025673e78.svg";